import { StoreEnum } from 'schema/storeCode';

export const DEFAULT_MAX_QUANTITY = 6;

export const AG1_POUCH_TITLE_LOWERCASE = 'ag1 pouch';
export const METAL_SCOOP_TITLE_LOWERCASE = 'metal scoop';

export const PRODUCTS_BY_STORE: {
  [key in StoreEnum]: {
    [prop: string]: string | undefined;
  };
} = {
  us: {
    scoop: 'gid://shopify/ProductVariant/40291982901346',
    scoopV53: 'gid://shopify/ProductVariant/41624842633314',
    scoopFirstOrder: 'gid://shopify/ProductVariant/41227924537442',
    packs5ct: 'gid://shopify/ProductVariant/41227930927202',
    packs5ctV53: 'gid://shopify/ProductVariant/41592075550818',
    subPouch: 'gid://shopify/ProductVariant/41224153628770',
    subPouchDouble: 'gid://shopify/ProductVariant/41224153661538',
    subPouchV53: 'gid://shopify/ProductVariant/41592067031138',
    subPouchV53Tropical: 'gid://shopify/ProductVariant/41592067162210',
    subPacks: 'gid://shopify/ProductVariant/41224153759842',
    subPacksDouble: 'gid://shopify/ProductVariant/41224153792610',
    agzChocolate: 'gid://shopify/ProductVariant/41869807353954',
    agzChocolateMint: 'gid://shopify/ProductVariant/41869807321186',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/41224650752098',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/41224650817634',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/41224650784866',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/41224650653794',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/41224650686562',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/41224650719330',
    welcomeKitBundle: 'gid://shopify/ProductVariant/41817011945570',
    welcomeKitAgz: 'gid://shopify/ProductVariant/41865625141346',
    welcomeKitPouchOTPV53: 'gid://shopify/ProductVariant/41613281263714',
    welcomeKitPouchSingleV53: 'gid://shopify/ProductVariant/41613281788002',
    welcomeKitPouchDoubleV53: 'gid://shopify/ProductVariant/41613297418338',
    welcomeKitPacksOTPV53: 'gid://shopify/ProductVariant/41613298499682',
    welcomeKitPacksSingleV53: 'gid://shopify/ProductVariant/41613299155042',
    welcomeKitPacksDoubleV53: 'gid://shopify/ProductVariant/41613299482722',
    familyPlanShaker: 'gid://shopify/ProductVariant/41518710325346',
    freeD3: 'gid://shopify/ProductVariant/41382101385314',
    discountedOmega3: 'gid://shopify/ProductVariant/41814907912290'
  },
  au: {
    scoop: 'gid://shopify/ProductVariant/41909798699106',
    scoopFirstOrder: 'gid://shopify/ProductVariant/41909796700258',
    packs5ct: 'gid://shopify/ProductVariant/41909799518306',
    otpPouch: 'gid://shopify/ProductVariant/41909788803170',
    subPouch: 'gid://shopify/ProductVariant/41909790703714',
    subPouchDouble: 'gid://shopify/ProductVariant/41909790834786',
    otpPacks: 'gid://shopify/ProductVariant/41909790244962',
    subPacks: 'gid://shopify/ProductVariant/41909791424610',
    subPacksDouble: 'gid://shopify/ProductVariant/41909792637026',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/41909792702562',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/41909793521762',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/41909794406498',
    welcomeKitPouchFamily: 'gid://shopify/ProductVariant/41909795291234',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/41909795324002',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/41909795422306',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/41909795749986',
    familyPlanShaker: 'gid://shopify/ProductVariant/41909802106978',
    freeD3: 'gid://shopify/ProductVariant/41909801222242',
    discountedOmega3: 'gid://shopify/ProductVariant/41909801451618'
  },
  nz: {
    scoop: 'gid://shopify/ProductVariant/41909798699106',
    scoopFirstOrder: 'gid://shopify/ProductVariant/41909796700258',
    packs5ct: 'gid://shopify/ProductVariant/41909799518306',
    otpPouch: 'gid://shopify/ProductVariant/41909788803170',
    subPouch: 'gid://shopify/ProductVariant/41909790703714',
    subPouchDouble: 'gid://shopify/ProductVariant/41909790834786',
    otpPacks: 'gid://shopify/ProductVariant/41909790244962',
    subPacks: 'gid://shopify/ProductVariant/41909791424610',
    subPacksDouble: 'gid://shopify/ProductVariant/41909792637026',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/41909792702562',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/41909793521762',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/41909794406498',
    welcomeKitPouchFamily: 'gid://shopify/ProductVariant/41909795291234',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/41909795324002',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/41909795422306',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/41909795749986',
    familyPlanShaker: 'gid://shopify/ProductVariant/41909802106978',
    freeD3: 'gid://shopify/ProductVariant/41909801222242',
    discountedOmega3: 'gid://shopify/ProductVariant/41909801451618'
  },
  jp: {
    scoop: 'gid://shopify/ProductVariant/40291982901346',
    scoopV53: 'gid://shopify/ProductVariant/41624842633314',
    subPouch: 'gid://shopify/ProductVariant/41224153628770',
    subPouchV53: 'gid://shopify/ProductVariant/41592067031138',
    subPouchV53Tropical: 'gid://shopify/ProductVariant/41592067162210'
  },
  qa: {
    scoop: 'gid://shopify/ProductVariant/41106228969515',
    scoopV53: 'gid://shopify/ProductVariant/41208233033771',
    packs5ct: 'gid://shopify/ProductVariant/41101566804011',
    packs5ctV53: 'gid://shopify/ProductVariant/41206688186411',
    packs3ct: 'gid://shopify/ProductVariant/42187014766635',
    subPouch: 'gid://shopify/ProductVariant/41101566836779',
    subPouchDouble: 'gid://shopify/ProductVariant/41101566869547',
    subPouchV53: 'gid://shopify/ProductVariant/41206686973995',
    subPouchV53Tropical: 'gid://shopify/ProductVariant/41207480483883',
    subPacks: 'gid://shopify/ProductVariant/41101567066155',
    subPacksDouble: 'gid://shopify/ProductVariant/41101567098923',
    agzChocolate: 'gid://shopify/ProductVariant/41940566179883',
    agzChocolateMint: 'gid://shopify/ProductVariant/41941038923819',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/41106301354027',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/41106303844395',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/41106301812779',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/41106298273835',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/41106300698667',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/41106301059115',
    welcomeKitAgz: 'gid://shopify/ProductVariant/41409553956907',
    welcomeKitPouchOTPV53: 'gid://shopify/ProductVariant/41413479399467',
    welcomeKitPouchSingleV53: 'gid://shopify/ProductVariant/41413479432235',
    welcomeKitPouchDoubleV53: 'gid://shopify/ProductVariant/41413479465003',
    welcomeKitPacksOTPV53: 'gid://shopify/ProductVariant/41413479497771',
    welcomeKitPacksSingleV53: 'gid://shopify/ProductVariant/41413479759915',
    welcomeKitPacksDoubleV53: 'gid://shopify/ProductVariant/41413479858219',
    familyPlanShaker: 'gid://shopify/ProductVariant/41190379946027',
    freeD3: 'gid://shopify/ProductVariant/41102341079083',
    discountedOmega3: 'gid://shopify/ProductVariant/40653443989547'
  },
  aud: {
    scoop: 'gid://shopify/ProductVariant/41463142318123',
    scoopFirstOrder: 'gid://shopify/ProductVariant/41463141892139',
    packs5ct: 'gid://shopify/ProductVariant/41463141728299',
    otpPouch: 'gid://shopify/ProductVariant/41463139467307',
    subPouch: 'gid://shopify/ProductVariant/41463143694379',
    subPouchDouble: 'gid://shopify/ProductVariant/41463141105707',
    otpPacks: 'gid://shopify/ProductVariant/41463139500075',
    subPacks: 'gid://shopify/ProductVariant/41463141171243',
    subPacksDouble: 'gid://shopify/ProductVariant/41463141302315',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/41463141400619',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/41463141433387',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/41463141531691',
    welcomeKitPouchFamily: 'gid://shopify/ProductVariant/41463141531691',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/41463141564459',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/41463141629995',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/41463141695531',
    familyPlanShaker: 'gid://shopify/ProductVariant/41909802106978',
    freeD3: 'gid://shopify/ProductVariant/41463141793835',
    discountedOmega3: 'gid://shopify/ProductVariant/41463141859371'
  },
  nzd: {
    scoop: 'gid://shopify/ProductVariant/41463142318123',
    scoopFirstOrder: 'gid://shopify/ProductVariant/41463141892139',
    packs5ct: 'gid://shopify/ProductVariant/41463141728299',
    otpPouch: 'gid://shopify/ProductVariant/41463139467307',
    subPouch: 'gid://shopify/ProductVariant/41463143694379',
    subPouchDouble: 'gid://shopify/ProductVariant/41463141105707',
    otpPacks: 'gid://shopify/ProductVariant/41463139500075',
    subPacks: 'gid://shopify/ProductVariant/41463141171243',
    subPacksDouble: 'gid://shopify/ProductVariant/41463141302315',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/41463141400619',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/41463141433387',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/41463141531691',
    welcomeKitPouchFamily: 'gid://shopify/ProductVariant/41463141531691',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/41463141564459',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/41463141629995',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/41463141695531',
    familyPlanShaker: 'gid://shopify/ProductVariant/41909802106978',
    freeD3: 'gid://shopify/ProductVariant/41463141793835',
    discountedOmega3: 'gid://shopify/ProductVariant/41463141859371'
  },
  uk: {
    scoop: 'gid://shopify/ProductVariant/41106228969515', // not available yet
    subPouch: 'gid://shopify/ProductVariant/41101566836779', // not available yet
    freeD3: 'gid://shopify/ProductVariant/41282961440845',
    discountedOmega3: 'gid://shopify/ProductVariant/41282961473613',
    // V52
    packs5ct: 'gid://shopify/ProductVariant/41282961408077',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/53489816994173',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/53489817059709',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/53489817158013',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/53489817190781',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/53489817223549',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/53489817256317',
    // V53
    packs5ctV53: 'gid://shopify/ProductVariant/41282961408077',
    welcomeKitPouchOTPV53: 'gid://shopify/ProductVariant/53489816994173',
    welcomeKitPouchSingleV53: 'gid://shopify/ProductVariant/53489817059709',
    welcomeKitPouchDoubleV53: 'gid://shopify/ProductVariant/53489817158013',
    welcomeKitPacksOTPV53: 'gid://shopify/ProductVariant/53489817190781',
    welcomeKitPacksSingleV53: 'gid://shopify/ProductVariant/53489817223549',
    welcomeKitPacksDoubleV53: 'gid://shopify/ProductVariant/53489817256317'
  },
  eu: {
    scoop: 'gid://shopify/ProductVariant/41106228969515', // not available yet
    subPouch: 'gid://shopify/ProductVariant/41101566836779', // not available yet
    freeD3: 'gid://shopify/ProductVariant/49978522206548',
    discountedOmega3: 'gid://shopify/ProductVariant/49978522468692',
    // V52
    packs5ct: 'gid://shopify/ProductVariant/49978521780564',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/49969192993108',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/49969193386324',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/49969193517396',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/49969193714004',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/49969194139988',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/49969195254100',
    // V53
    packs5ctV53: 'gid://shopify/ProductVariant/49978521780564',
    welcomeKitPouchOTPV53: 'gid://shopify/ProductVariant/49969192993108',
    welcomeKitPouchSingleV53: 'gid://shopify/ProductVariant/49969193386324',
    welcomeKitPouchDoubleV53: 'gid://shopify/ProductVariant/49969193517396',
    welcomeKitPacksOTPV53: 'gid://shopify/ProductVariant/49969193714004',
    welcomeKitPacksSingleV53: 'gid://shopify/ProductVariant/49969194139988',
    welcomeKitPacksDoubleV53: 'gid://shopify/ProductVariant/49969195254100'
  },
  dev: {
    scoop: 'gid://shopify/ProductVariant/48709469569339',
    subPouch: 'gid://shopify/ProductVariant/48768328663355',
    welcomeKitPouchOTP: 'gid://shopify/ProductVariant/48768088736059',
    welcomeKitPouchSingle: 'gid://shopify/ProductVariant/48769478656315',
    welcomeKitPouchDouble: 'gid://shopify/ProductVariant/48769586168123',
    welcomeKitPacksOTP: 'gid://shopify/ProductVariant/48768088998203',
    welcomeKitPacksSingle: 'gid://shopify/ProductVariant/48768088998203',
    welcomeKitPacksDouble: 'gid://shopify/ProductVariant/48768089686331'
  },
  eud: {
    scoop: 'gid://shopify/ProductVariant/41106228969515', // not available yet
    subPouch: 'gid://shopify/ProductVariant/41101566836779' // not available yet
  },
  ukd: {
    scoop: 'gid://shopify/ProductVariant/49709824049452',
    subPouch: 'gid://shopify/ProductVariant/41101566836779' // not available yet
  }
};
